import React from 'react';

import { Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import ListTableWrapper from '@sharedCR/common/ListTableWrapper';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import PropTypes from 'prop-types';

import { PendingChangeKind } from 'constants/pendingChanges';

import { getTableCellPendingChangesStyles, getTableCellStyles } from './ListTable.styles';

const defaultCustomStyles = {};

const ListTable = ({
  rows,
  title = '',
  isFullWidthDivider = false,
  customStyles = defaultCustomStyles,
  titleVariant = 'medium20',
}) => {
  return (
    <ListTableWrapper
      customStyles={customStyles}
      isFullWidthDivider={isFullWidthDivider}
      title={title}
      titleVariant={titleVariant}
    >
      <Table className="table">
        <TableBody className="table-body">
          {rows.map(
            ({
              label,
              value,
              isFullRowIndication,
              changeKind,
              firstCellCustomStyles,
              secondCellCustomStyles,
            }) => {
              return (
                <PendingChangeWrapper
                  changeKind={isFullRowIndication ? changeKind : null}
                  className="table-row"
                  component={TableRow}
                  data-row-key={label}
                  key={label}
                  textSelector="span"
                >
                  <TableCell
                    align="left"
                    className="table-cell"
                    sx={getTableCellStyles({
                      customStyles: firstCellCustomStyles,
                      isFullWidthDivider,
                    })}
                  >
                    <Typography variant="regular14">{label}</Typography>
                  </TableCell>
                  <TableCell
                    align="right"
                    className="table-cell"
                    sx={getTableCellStyles({
                      customStyles: secondCellCustomStyles,
                      isFullWidthDivider,
                    })}
                  >
                    <PendingChangeWrapper
                      isSmall
                      changeKind={isFullRowIndication ? null : changeKind}
                      sx={getTableCellPendingChangesStyles({
                        isModified: !isFullRowIndication && changeKind === PendingChangeKind.DIRECT,
                      })}
                      textSelector="span"
                    >
                      <Typography data-truncated className="truncate value" variant="bold16">
                        {value}
                      </Typography>
                    </PendingChangeWrapper>
                  </TableCell>
                </PendingChangeWrapper>
              );
            },
          )}
        </TableBody>
      </Table>
    </ListTableWrapper>
  );
};

ListTable.propTypes = {
  rows: PropTypes.array.isRequired,
  titleVariant: PropTypes.string,
  customStyles: PropTypes.object,
  title: PropTypes.string,
  isFullWidthDivider: PropTypes.bool,
};

export default ListTable;
